import Search from "@/modules/projectA/components/common/e-search";
import TableList from "@/modules/projectA/components/common/e-table-list";
export default {
  components: {
    Search,
    TableList
  }
}